<template>
  <div class="incenters">
    <div style="">
      <Commonbtn backgroundColor="#FFF" v-if="qx.add" title="新增" fontSize="14px" @btnclick="adduser" :src="require('@/assets/icon/icon-add.png')">
      </Commonbtn>
      <Commonbtn backgroundColor="#FFF" v-if="qx.update" :useAutoOptional="false" :optional="!rowboo" title="修改" fontSize="14px" @btnclick="update" :src="require('@/assets/icon/icon-update.png')">
      </Commonbtn>
      <Commonbtn backgroundColor="#FFF" v-if="qx.del" title="删除" fontSize="14px" @btnclick="del" :src="require('@/assets/icon/icon-del.png')">
      </Commonbtn>
    </div>
    <!-- style="border: 1px solid blue;" -->
    <div  class="TableWidth">
      <Commontable @onRowClick="onRowClick" colnum=7 :tableData="tableData" :headerData="headerData" height="100%">
      </Commontable>
      <div class="pagination">
        <Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange" :total="total"></Pagination>
      </div>
    </div>
    <DialogFrom width="1000px" title="新增产品线档案" :dialogVisible="dialogVisibles" @cancel="cancel" @dialogOK="dialogOK">
      <div class="from">
        <template v-for="(item , index) of fromdataadd">
          <Commondropdownlist  @gsChage="gsChage" :radio="item.radio" :pt="pt" :jxs="jxs" :event="item.event" @remoteMethod="remoteMethod" @remoteMethodtow="remoteMethodtow" ref="wareadd" :icon="item.icon" :autocomplete="item.autocomplete" :key="index" :options="item.options" :btx="item.btx" :inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color" :radiotitle1="item.radiotitle1" :radiotitle2="item.radiotitle2" :lablewith="item.lablewith" :placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype" :width="item.width" :min="item.min" :max="item.max" :checkboxdata="item.checkboxdata" :disabled="item.disabled" @city="city" @province="province">
          </Commondropdownlist>
        </template>
      </div>

    </DialogFrom>
    <DialogFrom width="1000px" title="修改产品线档案" :dialogVisible="dialogVisiblesedit" @cancel="canceledit" @dialogOK="dialogOKedit">
      <div class="from">
        <template v-for="(item , index) of fromdataedit">
          <Commondropdownlist @gsChageupdate="gsChageupdate" :pt="pt" :jxs="jxs" :event="item.event" @remoteMethod="remoteMethod" @remoteMethodtow="remoteMethodtow" ref="wareupdate" :icon="item.icon" :autocomplete="item.autocomplete" :key="index" :options="item.options" :btx="item.btx" :inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color" :radiotitle1="item.radiotitle1" :radiotitle2="item.radiotitle2" :lablewith="item.lablewith" :placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype" :width="item.width" :min="item.min" :max="item.max" :checkboxdata="item.checkboxdata" :disabled="item.disabled" @city="city" @province="province">
          </Commondropdownlist>
        </template>
      </div>
    </DialogFrom>

    <DialogFrom width="1000px" title="选择" :dialogVisible="dialogVisibleschooes" @cancel="cancelchooes" @dialogOK="dialogOKchooes">
      <div class="from">
        <div class="inputtop" v-if="showorhide">
          <template v-for="(item , index) of chooesdata">
            <Commondropdownlist :btx="item.btx" :key="index" :options="item.options" :minrigth="item.minrigth" :maxrigth="item.maxrigth" :minleft="item.minleft" :maxleft="item.maxleft" :lablewith="item.lablewith" :inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color" :placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype" :width="item.width"></Commondropdownlist>
          </template>
          <div style="display: inline-block;float: right;margin-right: 20px;">
            <CommonBtngroup :show="showorhide" ref="btngroup" @showclick="showclick" @hide="hide" @reset="reset" :qhide="true"></CommonBtngroup>
          </div>
          <div style="height:10px;">
          </div>
        </div>
        <div class="inputtops" v-else>
          <div style="display: inline-block;" v-for="(item , index) of chooesdata.slice(0,0)" :key="index">
            <Commondropdownlist ref="msgFormSon" :btx="item.btx" :minrigth="item.minrigth" :maxrigth="item.maxrigth" :minleft="item.minleft" :maxleft="item.maxleft" :lablewith="item.lablewith" :inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color" :placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype" :width="item.width"></Commondropdownlist>
          </div>
          <div style="display: inline-block;float: right;margin-right: 0px;">
            <CommonBtngroup ref="btngroup" :show="showorhide" @showclick="showclick" @hide="hide" @select="select" @reset="reset"></CommonBtngroup>
          </div>
          <div style="height:10px;">
          </div>
        </div>
      </div>
      <div style="width: 970px;">
        <WarehouserarTable :tableDatas="tableDatas" :totals="totals" @handleCurrentChange="handleCurrentChanges" @handleSizeChange="handleSizeChanges"></WarehouserarTable>
      </div>
    </DialogFrom>
    <Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledel" @cancel="canceldel" @dialogOK="dialogOKdel" :src="require('@/assets/icon/icon-del2.png')">
      <span style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要删除这条仓库档案吗？</span>
    </Dialog>
    <Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledeactivate" @cancel="canceldeactivate" @dialogOK="dialogOKdeactivate" :src="require('@/assets/icon/icon-del2.png')">
      <span style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要停用这条档案吗？</span>
    </Dialog>
  </div>
</template>
<script>
import Commondropdownlist from '../../../../components/common-dropdownlist.vue'
import Commontable from '../../../../components/common-table.vue'
import Commonbtn from '../../../../components/common-btn.vue'
import Pagination from '../../../../components/pagination.vue'
import DialogFrom from '../../../../components/dialog-from.vue'
import fromdata from '../fromData/add'
import fromdataedit from '../fromData/edit'
import chooesdata from '../fromData/chooesdata'
import Dialog from '../../../../components/dialog.vue'
import Commondown from '../../../../components/common-down.vue'
import CommonBtngroup from '../../../../components/commongroup.vue'
import WarehouserarTable from '../components/components/warehouserarTable.vue'
import {
  WarehouseInfo,
  WarehouseAdd,
  WarehouseEdit,
  WarehouseDelete,
  CustomerList,
  GetProvince,
  GetCity,
  GetDistrict,
  BaOrganizationList
} from '@/api/home'
export default {
  components: {
    Commontable,
    Commonbtn,
    Pagination,
    DialogFrom,
    Commondropdownlist,
    Dialog,
    Commondown,
    CommonBtngroup,
    WarehouserarTable
  },
  props: {
    tableData: {
      type: Array,
      default: []
    },
    total: {
      type: Number,
      default: 0
    }
  },
  data: function () {
    return {
      rowboo: false,
      dialogVisibleschooes: false,
      dialogVisibles: false,
      dialogVisiblesedit: false,
      dialogVisibledel: false,
      dialogVisibledeactivate: false,
      dialogVisiblesU8: false,
      dialogVisiblesU8d: false,
      rightboo: false,
      dwonleft: false,
      showorhide: true,
      WHCode: "",
      CusNames: "",
      CusNameCode: "",
      CusNameCodes: "",
      loading: true,
      from: {
        whCode: "",
        whName: "",
        whAbbr: "",
        tagID: "",
        linkMan: "",
        linkPhone: "",
        provinceID: "",
        cityID: "",
        districtID: "",
        address: "",
        consignment: "",
        whType: "",
        cusCode: "",
        cusCode12: ""
      },
      pageindex: 1,
      pageSize: 20,
      totals: 0,
      tableDatas: [],
      ptype: '',
      fromdataadd: [],
      fromdataedit: [],
      chooesdata: [],
      fromdataU8: [{
        inputdata: '',
        title: 'U8账套',
        fontSize: '14px',
        color: '#333333',
        placeholder: '请输入',
        types: 'text',
        inputtype: 'input',
        width: '210px',
        lablewith: '55px'
      }, {
        inputdata: '',
        title: 'U8编号',
        fontSize: '14px',
        color: '#333333',
        placeholder: '请输入',
        types: 'text',
        inputtype: 'input',
        width: '210px',
      },],
      headerData: [{
        prop: 'id',
        label: '序号',
        columnwidth: 50
      },
      {
        prop: 'WHCode',
        label: '仓库编号',
        columnwidth: 80
      },
      {
        prop: 'WHName',
        label: '仓库名称',
        columnwidth: 280
      },
      {
        prop: 'WHAbbr',
        label: '仓库缩写 ',
        columnwidth: 80
      },
      {
        prop: 'LinkMan',
        label: '联系人',
        columnwidth: 80
      },
      {
        prop: 'LinkPhone',
        label: '联系电话',
        columnwidth: 80
      },
      {
        prop: 'Province',
        label: '省份',
        columnwidth: 80
      },
      {
        prop: 'City',
        label: '城市',
        columnwidth: 80
      },
      {
        prop: 'District',
        label: '区县',
        columnwidth: 80
      },
      {
        prop: 'Address',
        label: '地址',
        columnwidth: 80
      },
      {
        prop: 'Consignment',
        label: '是否寄售',
        columnwidth: 80
      },
      {
        prop: 'WhType',
        label: '仓库归属（选择平台或经销商）',
        columnwidth: 180
      },
      {
        prop: 'CusCode',
        label: '所属平台或经销商编号',
        columnwidth: 150
      },
      {
        prop: 'Deleted',
        label: '是否删除',
        columnwidth: 80
      },
      {
        prop: 'Creator',
        label: '创建人',
        columnwidth: 130
      },
      {
        prop: 'CreateTime',
        label: '创建时间',
        columnwidth: 130
      },
      {
        prop: 'Updater',
        label: '修改人',
        columnwidth: 130
      },
      {
        prop: 'UpdateTime',
        label: '修改时间',
        columnwidth: 130
      },
      ],
      tableData1: [{
        kong: '',
        U8id: '1',
        U8number: '102100024',
      },
      {
        kong: '',
        U8id: '2',
        U8number: '102100024',
      },
      {
        kong: '',
        U8id: '3',
        U8number: '102100024',
      },
      ],
      headerData1: [{
        prop: 'kong',
        columnwidth: 39,
        types: 'selection'

      },
      {
        prop: 'U8id',
        label: 'U8账套',
        columnwidth: 400,

      },
      {

        prop: 'U8number',
        label: 'U8编号',
        columnwidth: 522
      },
      ],
      downlist: [{
        title: 'U8配置'
      },
      {
        title: '导入U8配置'
      },
      ],
      qus: [],
      qx: {
        add: true,
        update: true,
        del: true,
        stopif: true,
        daoc: true,
        assignment: true,
        enabled: true,
        submit: true,
        skip: true,//跳过
        reset: true, //重置
        setting: true
      },
      pt: false,
      jxs: false,
      ptupdate: false,
      jxsupdate: false,
      cusCodedata: null,
      listData: null
    }
  },
  mounted() {
    this.QX()
    this.fromdataadd = JSON.parse(JSON.stringify(fromdata))
    this.fromdataedit = JSON.parse(JSON.stringify(fromdataedit))
    this.chooesdata = JSON.parse(JSON.stringify(chooesdata))

  },
  methods: {
    QX() {
      let data = JSON.parse(localStorage.getItem("MenusData"))
        data.Menus[0].Nodes.map((item, index) => {
        if (item.NodeID == 35) {
          item.Nodes.map((items, indexs) => {
            if (items.NodeID == 41) {
              this.qus = items.Nodes
            }
          })
        }
      // console.log(this.qus, 'this.qus');
      })
      
      if (this.qus) {
        this.qus.map((item, index) => {
          if (item.NodeName == 'add') {
            this.qx.add = true
          } else if (item.NodeName == 'edit') {
            this.qx.update = true
          } else if (item.NodeName == 'delete') {
            this.qx.del = true
          } else if (item.NodeName == 'stopif') {
            this.qx.del = true
          } else if (item.NodeName == 'assignment') {
            this.qx.assignment = true
          } else if (item.NodeName == 'enabled') {
            this.qx.enabled = true
          } else if (item.NodeName == 'skip') {
            this.qx.skip = true
          } else if (item.NodeName == 'reset') {
            this.qx.reset = true
          } else if (item.NodeName == 'setting') {
            this.qx.setting = true
          }
        })
      }


      //console.log("qux", this.qus)
    },
    async customerList() {
      let list = await CustomerList({
        // name: this.zname,
        // type: this.type,
        // parentId: this.parentId,
        pageSize: this.pageSize,
        pageIndex: this.pageindex
      })
      if (list.code == 0) {
        this.totals = list.data.Count
        this.tableDatas = list.data.data
      }
      //console.log("list", list.data.data)
    },
    // 新增
    async warehouseAdd() {
      let {
        code,
        message
      } = await WarehouseAdd({
        whCode: this.from.whCode,
        whName: this.from.whName,
        whAbbr: this.from.whAbbr,
        tagID: this.from.tagID,
        linkMan: this.from.linkMan,
        linkPhone: this.from.linkPhone,
        provinceID: Number(this.from.provinceID),
        cityID: Number(this.from.cityID),
        districtID: Number(this.from.districtID),
        address: this.from.address,
        consignment: Number(this.from.consignment),
        whType: this.from.whType,
        cusCode: this.from.cusCode || this.from.cusCode12,
      })
      if (code == 0) {
        this.$message({
          type: 'success',
          message: '新增成功'
        });
        this.$refs.wareadd.map((item, index) => {
          if (index != 9) {
            item.modelvalue = ''
          }
        })
        this.rowboo = false
        this.$parent.warehouseList()
      } else {
        this.$message({
          type: 'error',
          message: message
        });
      }
    },
    async CustomerList() {
      let {
        data,
        code
      } = await CustomerList({

      })
      if (code == 0) {
        this.listData = data.data
      }
    },
    // 详情
    async warehouseInfo() {
      let {
        code,
        data

      } = await WarehouseInfo({
        WHCode: this.WHCode
      })
      if (code == 0) {
        this.getProvince()
        this.$refs.wareupdate[0].modelvalue = data.WHCode
        this.$refs.wareupdate[1].modelvalue = data.WHName
        this.$refs.wareupdate[2].modelvalue = data.WHAbbr

        this.$refs.wareupdate[3].modelvalue = data.ProvinceID == 0 ? "" : String(data.ProvinceID)
        this.$refs.wareupdate[4].modelvalue = data.CityID == 0 ? "" : String(data.CityID)
        this.$refs.wareupdate[5].modelvalue = data.DistrictID == 0 ? "" : String(data.DistrictID)

        this.$refs.wareupdate[6].modelvalue = data.Address
        this.$refs.wareupdate[7].modelvalue = data.LinkMan
        this.$refs.wareupdate[8].modelvalue = data.LinkPhone

        this.$refs.wareupdate[9].radios = data.Consignment + ""
        this.$refs.wareupdate[10].modelvalue = data.WhType
        this.$refs.wareupdate[11].modelvalue = data.CusName
        this.$refs.wareupdate[12].modelvalue = data.CusName
        //console.log( data.CusCode,' data.CusCode');
        this.CusNames = data.CusName
        this.CusNameCodes = data.CusCode
        //console.log(this.CusNames, '99');
        if (this.$refs.wareupdate[10].modelvalue == '平台') {
          this.baOrganizationList(data.CusName)
          this.pt = true
          this.jxs = false
        } else if (this.$refs.wareupdate[10].modelvalue == '经销商') {
          this.customerList(data.CusName)
          this.jxs = true
          this.pt = false
        }
        this.getcity(data.ProvinceID)
        this.getDistrict(data.CityID)
      }
    },
    // 修改
    async warehouseEdit(datalist) {
      let {
        code,
        message
      } = await WarehouseEdit({
        whCode: datalist[0].modelvalue,
        whName: datalist[1].modelvalue,
        whAbbr: datalist[2].modelvalue,
        // tagID: datalist[0].modelvalue,
        linkMan: datalist[7].modelvalue,
        linkPhone: datalist[8].modelvalue,
        provinceID: Number(datalist[3].modelvalue),
        cityID: Number(datalist[4].modelvalue),
        districtID: Number(datalist[5].modelvalue),
        address: datalist[6].modelvalue,
        consignment: Number(datalist[9].radios),
        whType: datalist[10].modelvalue,
        cusCode: datalist[10].modelvalue == "平台" ? datalist[11].modelvalue == this.CusNames ? this.CusNameCodes : datalist[11].modelvalue  : datalist[12].modelvalue == this.CusNames ? this.CusNameCodes : datalist[12].modelvalue,
      })
      if (code == 0) {
        this.$message({
          type: 'success',
          message: '修改成功'
        });
        this.rowboo = false
        this.dialogVisiblesedit = false
        this.$parent.warehouseList()
      } else {
        this.$message({
          type: 'error',
          message: message
        });
      }
    },
    // 删除
    async warehouseDelete() {
      let {
        code,
        message
      } = await WarehouseDelete({
        WHCode: this.WHCode
      })
      if (code == 0) {
        this.$message({
          type: 'success',
          message: '删除成功'
        });
        this.$parent.warehouseList()
      } else {
        this.$message({
          type: 'error',
          message: message
        });
      }
    },

    // 省
    async getProvince() {
      let {
        code,
        data
      } = await GetProvince({

      })
      if (code == 0) {
        this.fromdataadd[3].options = []
        this.fromdataedit[3].options = []
        data.map((item, index) => {
          let obj = {
            key: item.Value,
            value: item.Text
          }
          this.fromdataadd[3].options.push(obj)
          this.fromdataedit[3].options.push(obj)
        })
      }
    },
    // 市
    async getcity(provinceid) {
      let params = {
        ProvinceID: provinceid
      }
      let {
        code,
        data
      } = await GetCity({
        params
      })
      if (code == 0) {
        this.fromdataadd[4].options = []
        this.fromdataedit[4].options = []
        data.map((item, index) => {
          let obj = {
            key: item.Value,
            value: item.Text
          }
          this.fromdataadd[4].options.push(obj)
          this.fromdataedit[4].options.push(obj)
        })
      }
    },
    // 区
    async getDistrict(cityID) {
      let params = {
        CityID: cityID
      }
      let {
        code,
        data
      } = await GetDistrict({
        params
      })
      if (code == 0) {
        this.fromdataadd[5].options = []
        this.fromdataedit[5].options = []
        data.map((item, index) => {
          let obj = {
            key: item.Value,
            value: item.Text
          }
          this.fromdataadd[5].options.push(obj)
          this.fromdataedit[5].options.push(obj)
        })
      }
    },
    province(val) {
      this.getcity(val)
    },
    city(val) {
      this.getDistrict(val)
    },
    showclick() {
      this.showorhide = true
    },
    hide() {
      this.showorhide = false

    },
    select() {

    },
    reset() {

    },
    iconclick() {
      this.customerList()
      this.dialogVisibleschooes = true
    },
    dialogOKchooes() {
      this.dialogVisibleschooes = false
    },
    cancelchooes() {
      this.dialogVisibleschooes = false
    },
    commclick(type) {
      this[type] = true
    },
    onRowClick(val) {
      this.rowboo = true
      this.WHCode = val.WHCode
      //console.log(val, "val")
    },
    handleCurrentChange(pageindex) {
      this.$emit('handleCurrentChange', pageindex)
    },
    handleSizeChange(paegSzie) {
      this.$emit('handleSizeChange', paegSzie)
    },
    handleCurrentChanges(pageindex) {
      this.pageindex = pageindex
      this.customerList()
      //console.log(pageindex, 'pageindex')

    },
    handleSizeChanges(paegSzie) {
      this.pageSize = paegSzie
      this.customerList()

    },
    adduser() {
      this.getProvince()
      this.dialogVisibles = true
      //console.log(this.fromdataadd, '//console.log(this.fromdataadd)')
    },
    cancel() {
      this.dialogVisibles = false
    },
    dialogOK() {
      this.from.whCode = this.$refs.wareadd[0].modelvalue,
        this.from.whName = this.$refs.wareadd[1].modelvalue,
        this.from.whAbbr = this.$refs.wareadd[2].modelvalue,
        this.from.provinceID = this.$refs.wareadd[3].modelvalue,
        this.from.cityID = this.$refs.wareadd[4].modelvalue,
        this.from.districtID = this.$refs.wareadd[5].modelvalue,
        this.from.address = this.$refs.wareadd[6].modelvalue,

        this.from.linkMan = this.$refs.wareadd[7].modelvalue,
        this.from.linkPhone = this.$refs.wareadd[8].modelvalue,
        this.from.consignment = this.$refs.wareadd[9].modelvalue,
        this.from.whType = this.$refs.wareadd[10].modelvalue,

        this.from.tagID = this.$refs.wareadd[0].modelvalue,

        this.from.cusCode = this.$refs.wareadd[11].modelvalue,
        this.from.cusCode12 = this.$refs.wareadd[12].modelvalue,
        this.warehouseAdd()
      this.dialogVisibles = false
    },
    update() {
      if (this.rowboo == true) {
        this.warehouseInfo()
        this.CustomerList()
        this.dialogVisiblesedit = true
        return
      }
      this.$message({
        type: 'error',
        message: '请选择要修改的数据！'
      });

    },
    canceledit() {
      this.dialogVisiblesedit = false
    },
    dialogOKedit() {
      // this.qx = false
      // this.jxs = false
      this.warehouseEdit(this.$refs.wareupdate)
      
    },
    del() {
      if (this.rowboo == true) {
        this.dialogVisibledel = true
        return
      }
      this.$message({
        type: 'error',
        message: '请选择要删除的数据！'
      });

    },
    canceldel() {
      this.dialogVisibledel = false
    },
    dialogOKdel() {
      this.warehouseDelete()
      this.dialogVisibledel = false
    },
    deactivate() {
      this.dialogVisibledeactivate = true
    },
    canceldeactivate() {
      this.dialogVisibledeactivate = false
    },
    dialogOKdeactivate() {
      this.dialogVisibledeactivate = false
    },
    downs(index) {
      //console.log("index", index)
      if (index == 0) {
        this.dialogVisiblesU8 = true
      }
      if (index == 1) {
        this.dialogVisiblesU8d = true
      }
    },
    cancelU8() {
      this.dialogVisiblesU8 = false
    },
    dialogOKeditU8() {
      this.dialogVisiblesU8 = false
    },
    cancelU8d() {
      this.dialogVisiblesU8d = false
    },
    dialogOKeditU8d() {
      this.dialogVisiblesU8d = false
    },
    async baOrganizationList(query) {
      let {
        data,
        code
      } = await BaOrganizationList({
        companyName: query
      })
      if (code == 0) {
        this.CusNameCode = data.data[0].CusCode
      }
    },
    async remoteMethod(query) {
      this.loading = true
      let {
        data,
        code
      } = await BaOrganizationList({
        companyName: query
      })
      if (code == 0) {
        this.fromdataedit[11].options = []
        this.fromdataadd[11].options = []
        data.data.map((item, index) => {
          let obj = {
            key: item.CompanyID, //CompanyID
            value: item.CompanyName
          }
          this.fromdataedit[11].options.push(obj)
          this.fromdataadd[11].options.push(obj)

        })
        this.loading = false
      }
    },
    async customerList(query) {
      let {
        data,
        code
      } = await CustomerList({
        cusName: query
      })
      if (code == 0) {
         this.CusNameCode = data.data[0].CusCode
      }
    },
    async remoteMethodtow(query) {
      this.loading = true
      let {
        data,
        code
      } = await CustomerList({
        cusName: query
      })
      if (code == 0) {
        this.fromdataedit[12].options = []
        this.fromdataadd[12].options = []
        data.data.map((item, index) => {
          let obj = {
            key: item.CusCode,
            value: item.CusName
          }
          this.fromdataedit[12].options.push(obj)
          this.fromdataadd[12].options.push(obj)

        })
        this.loading = false
      }
    },
    gsChage(e) {
      if (e.modelvalue == '平台') {
        this.pt = true
        this.jxs = false
      } else if (e.modelvalue == '经销商') {
        this.jxs = true
        this.pt = false
      }
    },
    gsChageupdate(e) {
      if (e.modelvalue == '平台') {
        this.pt = true
        this.jxs = false
      } else if (e.modelvalue == '经销商') {
        this.jxs = true
        this.pt = false
      }
    },

  },
  watch: {

  }
}
</script>

<style lang="less" scoped>
.incenters {
  height: 100%;

  .pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 16px;
    padding-bottom: 16px;
  }

  // div {
  //   margin-left: 8px;
  //   margin-right: 8px;
  //   margin-top: 5px;
  //   margin-bottom: 5px;

  // }
  .from {
    width: 100%;
  }

  .signingroles {
    height: 500px;
    width: 100%;
    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    // border: 1px solid red;

    .left {
      height: 240px;
      width: 470px;
      border: 1px solid #e6e6e6;
    }

    .right {
      height: 240px;
      width: 470px;
      border: 1px solid #e6e6e6;
      // pointer-events: none;
    }
  }
}
.inputtop {
  width: 970px;
  height: 50px;
  // box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding-top: 15px;
  padding-bottom: 70px;
  animation: shows 0.2s ease-in;
  overflow: hidden;
}
.inputtops {
  width: 980px;
  height: 0;
  // box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding-top: 15px;
  padding-bottom: 70px;
  overflow: hidden;
  //  animation: hides 0.5s ease-in;
}
@keyframes shows {
  0% {
    height: 0px;
  }
  100% {
    height: 50px;
  }
}
@keyframes hides {
  0% {
    height: 50px;
  }
  100% {
    height: 0px;
  }
}
.right-s {
  position: absolute;
  z-index: 99;
  opacity: 0.5;
  right: 21px;
  width: 470px;
  height: 240px;
  background-color: #ffffff;
  cursor: no-drop;
}

.dwonleft {
  width: 170px;
  height: 48px;
  position: absolute;
  background-color: #ffffff;
  z-index: 99;
  right: 350px;
  top: 322px;
  text-align: center;
  line-height: 48px;
  color: #333333;
  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
    0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
  border-radius: 2px;
  font-size: 14px;
  cursor: pointer;
}

.dwonleft:hover {
  background-color: #f0f0f0;
}
</style>
